module.exports = new __parcel__URL__("8146.73960b57.jpg").toString();